var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("校運會報名")]),_vm._v(" "),(!_vm.info)?_c('login-form',{on:{"login":_vm.loginSuccess}}):_vm._e(),_vm._v(" "),(_vm.info)?_c('application-form',{attrs:{"info":_vm.info}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f550fa3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = a3gp
// module chunks = 1